<script>
import { mapGetters } from 'vuex'
export default
{
    name: 'logo',

    props:
    {
        red: Boolean
    },

    computed:
    {
        ...mapGetters({
            channel: 'channel'
        }),

        logoUrl()
        {
            return this.channel && this.channel.logos && this.channel.logos.length ? this.channel.logos[0].display_url : null
        }
    }

}
</script>

<template>
    <span class="logo" :class="{'red': red}" v-if="logoUrl">
        <img :src="logoUrl">
    </span>
</template>

<style lang="scss">
.logo {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: .05em;
    color: #737373;
    border-bottom: none;
    img {
        max-height: 120px;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/elements/Logo.vue